// extracted by mini-css-extract-plugin
var _1 = "Avatar-module__animateUploadProgressBarWidth--dbYqi";
var _2 = "Avatar-module__animatedBackground--z_OPa";
var _3 = "Avatar-module__avatar--AI0_h";
var _4 = "Avatar-module__color1--EA3bP";
var _5 = "Avatar-module__color2--G_suD";
var _6 = "Avatar-module__color3--LGxwT";
var _7 = "Avatar-module__color4--GfbSi";
var _8 = "Avatar-module__color5--eNEMB";
var _9 = "Avatar-module__color6--s6j_x";
var _a = "Avatar-module__large--CBXWi";
var _b = "Avatar-module__medium--c91Z0";
var _c = "Avatar-module__muted--yBhFn";
var _d = "Avatar-module__small--VdxRv";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatar", _4 as "color1", _5 as "color2", _6 as "color3", _7 as "color4", _8 as "color5", _9 as "color6", _a as "large", _b as "medium", _c as "muted", _d as "small" }
